//Image url to base64 with return
export const getBase64Image = (url) => {
  if (url) {
    const img = new Image()
    img.crossOrigin = 'anonymous'
    img.src = `${process.env.REACT_APP_IMAGE_URL}${url}`

    const canvas = document.createElement('canvas')
    canvas.width = img.height
    canvas.height = img.width
    const ctx: any = canvas.getContext('2d')
    ctx.drawImage(img, 0, 0)
    const dataURL = canvas.toDataURL()

    return dataURL
  }
}

// Image url to base64 with callback
export const convertImageToBase64 = (url, callback) => {
  if (url) {
    const image = new Image()
    image.crossOrigin = 'anonymous'
    image.src = `${process.env.REACT_APP_IMAGE_URL}${url}`

    image.onload = () => {
      const canvas = document.createElement('canvas')
      const ctx: any = canvas.getContext('2d')
      canvas.height = image.naturalHeight
      canvas.width = image.naturalWidth
      ctx.drawImage(image, 0, 0)
      const dataUrl = canvas.toDataURL()
      callback && callback(dataUrl)
    }
  }
}
